import PreneedPaymentForm from './PreneedPaymentForm'
import makeAsyncScriptLoader from 'react-async-script'

// Load Stripe.js v3 (supports PaymentIntents)
export default makeAsyncScriptLoader('https://js.stripe.com/v3/', {globalName: 'Stripe'})(PreneedPaymentForm)
